import { render, staticRenderFns } from "./TempConfigFormList.vue?vue&type=template&id=564330d6&scoped=true"
import script from "./TempConfigFormList.vue?vue&type=script&lang=js"
export * from "./TempConfigFormList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigFormList.vue?vue&type=style&index=0&id=564330d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564330d6",
  null
  
)

export default component.exports